var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "table-container"
  }, [_c("a-table", {
    attrs: {
      columns: _vm.productColumns,
      "data-source": _vm.productdata,
      loading: false,
      pagination: false,
      rowKey: (record, index) => {
        return index;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };